import { useState } from "react";

import type { OptionId, SingleChoiceConfig } from "../../blockTypes";
import ChoiceQuestion from "./ChoiceQuestion";

interface SingleChoiceBlockProps {
    config?: SingleChoiceConfig;
    onComplete?: () => void;
    onAnswer?: (isCorrect: boolean) => void;
}

const SingleChoiceBlock = ({ config, onComplete, onAnswer }: SingleChoiceBlockProps) => {
    const { prompt, options = [], correctOptionId, explanation } = config ?? {};

    const [selectedId, setSelectedId] = useState<OptionId | null>(null);
    const [isChecked, setIsChecked] = useState(false);

    const isCorrect = isChecked && selectedId === correctOptionId;

    const handleCheck = () => {
        if (selectedId === null || isChecked) return;

        const correct = selectedId === correctOptionId;
        setIsChecked(true);
        onAnswer?.(correct);
        if (correct) onComplete?.();
    };

    return (
        <ChoiceQuestion
            prompt={prompt}
            explanation={explanation}
            options={options}
            selectedIds={selectedId === null ? [] : [selectedId]}
            correctIds={correctOptionId === undefined ? [] : [correctOptionId]}
            isChecked={isChecked}
            isCorrect={isCorrect}
            onSelect={setSelectedId}
            onCheck={handleCheck}
        />
    );
};

export default SingleChoiceBlock;